var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowDown140 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 140,
  height: 140,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.146 41.146a.5.5 0 0 1 .708 0L69.5 96.793l55.646-55.647a.501.501 0 0 1 .708.708l-56 56a.5.5 0 0 1-.708 0l-56-56a.5.5 0 0 1 0-.708Z",
  clipRule: "evenodd"
})));
export { SvgArrowDown140 as ReactComponent };
export default __webpack_public_path__ + "459343733ddaebfbd83f8b55722d6ded.svg";